import { MRT_ColumnDef, MaterialReactTable } from 'material-react-table';
import { createGlobalStyle } from 'styled-components';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import React from 'react';

function MaterialTableComponent({ columns, rows, rowsPerPage }) {
  const normalizedColumns = React.useMemo(
    () => (columns as MRT_ColumnDef[]) || [],
    [columns],
  );

  const columnOrder = React.useMemo(
    () =>
      normalizedColumns
        .map((col: any) => col?.id || col?.accessorKey)
        .filter((id: string | undefined): id is string => Boolean(id)),
    [normalizedColumns],
  );

  return (
    <Container>
      <Styles />
      <MaterialReactTable
        key={columnOrder.join('|')}
        initialState={{
          pagination: { pageSize: rowsPerPage, pageIndex: 0 },
          columnOrder,
        }}
        state={{ columnOrder }}
        columns={normalizedColumns}
        data={rows}
        // defaultColumn={{
        //   minSize: 150, //allow columns to get smaller than default
        //   maxSize: 200, //allow columns to get larger than default
        //   size: 180, //make columns wider by default
        // }}
        enableColumnResizing={true}
        enableColumnOrdering={false}
        enableColumnActions={false}
        enableColumnFilters={false}
        enablePagination={true}
        muiTablePaginationProps={{
          rowsPerPageOptions: [rowsPerPage],
          showFirstButton: false,
          showLastButton: false,
          labelRowsPerPage: false,
        }}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={false}
        muiTableBodyRowProps={{
          hover: false,
        }}
        muiTableHeadCellProps={{
          sx: () => ({
            border: '1px solid rgba(81, 81, 81, 1)',
          }),
        }}
        muiTableProps={{
          sx: {
            border: '1px solid rgba(81, 81, 81, 1)',
            tableLayout: 'fixed',
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            whiteSpace: 'nowrap',
            textAlign: 'center',
            border: '1px solid rgba(81, 81, 81, 1)',
          },
        }}
        muiTableBodyProps={{
          sx: () => ({
            '& tr:nth-of-type(odd)': {
              backgroundColor: 'rgb(236, 241, 248)',
            },
          }),
        }}
        localization={{
          noRecordsToDisplay: 'Aucune donnée',
          goToNextPage: 'Suivant',
          goToPreviousPage: 'Précédent',
          search: 'chargement',
          sortedByColumnAsc: '{column} trié en ordre croissant',
          sortedByColumnDesc: '{column} trié en ordre décroissant',
          unsorted: 'Non trié',
          of: 'sur',
        }}
      />
    </Container>
  );
}
const Styles = createGlobalStyle`
.sds-reset-style{
  .MuiSvgIcon-root{
    width: 40px;
    height: 30px;
    margin-left: 5px;
  }
  .MuiTablePagination-toolbar{
    margin-right: 15px;
  }
  .MuiToolbar-root{
    height: 50px;
    z-index: 0;
  }
  .MuiPaper-root{
    box-shadow: none;
  }
  hr {
    border-width: 1px;
    opacity: 0.6;
  }
}`;
export default MaterialTableComponent;
